module.exports = __webpack_public_path__ + "static/media/05_Ministeredesaffairesetrangeres.c4a00617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_affaires-etrangeres/05_Ministeredesaffairesetrangeres.jpg
// module id = 1178
// module chunks = 37